"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyCommonTermsResponseSchema = exports.PolicyCommonTermsInputSchema = void 0;
var zod_1 = require("zod");
exports.PolicyCommonTermsInputSchema = zod_1.z.array(zod_1.z.string());
exports.PolicyCommonTermsResponseSchema = zod_1.z.array(zod_1.z.string());
